import React from "react";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { setInlineLoading } from "../Redux/slices/loader";
import { RegisterPageView } from "../Pixel";

import HomePage from "../Pages/HomePage";
import DefaultPage from "../Pages/DefaultPage";
import Product from "../Product/Product";
import SearchResults from "../Pages/SearchResults";
import TextPage from "../Pages/TextPage";
import ShopPage from "../Pages/ShopPage";
import ThankYou from "../Checkout/ThankYou";

export const pageTransitionDuration = 700;

const mapDispatchToProps = dispatch => {
    return {
        setInlineLoading: payload => dispatch(setInlineLoading(payload))
    }
}

class MainRouter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            location: props.location.pathname
        };
    }

    componentDidUpdate(prevProps) {
        // Pixels
        RegisterPageView();

        // Scroll to top if new page
        if (prevProps.location.pathname !== this.props.location.pathname && this.props.history.action === "PUSH") {
            setTimeout(() => {
                this.setState({
                    location: this.props.location.pathname
                });
                window.scrollTo({
                    top: 0
                });
            }, pageTransitionDuration);
        }
    }

    render() {
        const transitionProps = {
            timeout: pageTransitionDuration,
            mountOnEnter: true,
            unmountOnExit: true,
            classNames: "page-transition",
            key: this.props.location.pathname,
            onEnter: () => {
                this.props.setInlineLoading(true);
            },
            onExited: () => {
                this.props.setInlineLoading(false);
            }
        }

        return <TransitionGroup>
            <CSSTransition {...transitionProps}>
                <Switch location={this.props.location}>
                    <Route exact path="/" component={HomePage} />
                    <Route path="/search/" component={SearchResults} />
                    <Route path="/shop/:category/:path" component={Product} />

                    <Route path="/about-us" component={TextPage} />
                    <Route path="/contact-us" component={TextPage} />
                    <Route path="/store" component={TextPage} />
                    <Route path="/shipping-exchanges-returns" component={TextPage} />

                    <Route path="/checkout/thank-you" component={ThankYou} />

                    <Route path="/shop" component={ShopPage} />
                    <Route path="/" component={() => <DefaultPage location={this.state.location} />} />
                </Switch>
            </CSSTransition>
        </TransitionGroup>
    }
}

export default connect(null, mapDispatchToProps)(withRouter(MainRouter));